export class InjectionPressureDataRecord {
  public Id: number;
  public WellId: number;
  public MeasurementDate: Date;

  public ShutinBHPDaily: number;
  public ShutinBHPQuarterlyCalc: number;
  public ShutinBHPQuarterlyMeas: number;

  public TvdDepBHPSensor: number;
  public MeaDayInjLiqDens: number;
  public AveDayMeasBHP: number;
  public MaxDayMeasBHP: number;
  public AveDayEstBHP: number;
  public MaxDayEstBHP: number;
  public StaticDayMeasSurfPress: number;
  public ShutinTimeForStaticPress: number;
  public DateRowAdded: Date;
}
